import { useEffect, useRef } from "react";
import { useAuth } from "@/hooks/useAuth";
import { identify, reset, track } from "@/lib/analytics";

export function useAnalyticsIdentify(): void {
  const { user, isAuthenticated } = useAuth();
  const identifiedRef = useRef<string | null>(null);
  const signUpFiredRef = useRef(false);

  useEffect(() => {
    const userId = user?.id ?? null;

    if (userId && identifiedRef.current !== userId) {
      identify(userId, {
        email: user?.email ?? null,
        firstName: user?.firstName ?? null,
        lastName: user?.lastName ?? null,
      });
      identifiedRef.current = userId;

      if (user?.isNewUser && !signUpFiredRef.current) {
        track("sign_up", { method: "replit" });
        signUpFiredRef.current = true;
      }
      return;
    }

    if (!userId && identifiedRef.current) {
      reset();
      identifiedRef.current = null;
      signUpFiredRef.current = false;
    }
  }, [user, isAuthenticated]);
}
